<template>
  <slot></slot>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";
import { AccessToken as token } from "@/api/accessDecoder";
import { auth } from "@/config/host.config";
import { isServerReachable } from "@/services/connectivity";

@Options({
  name: "authorized",
  components: {},
})
class Authorized extends Vue {
  onlineInterval!: ReturnType<typeof setTimeout>;

  mounted(): void {
    this.chekin();
    this.onlineInterval = setInterval(() => {
      this.chekin();
    }, this.$second(10));
  }

  unmounted(): void {
    clearInterval(this.onlineInterval);
  }

  messagesHandler(): void {
    return;
  }

  async chekin(): Promise<void> {
    if (this.$route.name === "login") return;
    if (!token.isAuthorized) {
      token.logout();
      return;
    }
    // Не стучим на мёртвый сервер: восстановление сделает супервизор связности
    if (!isServerReachable()) return;

    const url = auth.access;
    const data = { status: "Online", path: this.$route.name };
    try {
      const tuktuk = await this.$axios.post(url, data);
      if (tuktuk.status === 200) {
        this.messagesHandler();
      }
    } catch (error) {
      this.$error(error);
    }
  }
}
export default Authorized;
</script>
<style lang="scss"></style>
